import React from "react";

export default function Introduction() {
  return (
    <div className="introduction">
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/4MbgWdafc6Y"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  );
}
